import { OnChanges, SimpleChanges, input, inject } from "@angular/core";
import { Directive, ElementRef } from "@angular/core";
import { BreakpointService } from "@app/core/services/breakpoint.service";

@Directive({
  selector: "[appScrollToElement]"
})
export class ScrollToElementDirective implements OnChanges {
  private element = inject(ElementRef, { self: true });
  private bps = inject(BreakpointService);
  appScrollToElement = input<boolean>(true);
  /**
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView for additional options.
   */
  block = input<string>("nearest");

  ngOnChanges(changes: SimpleChanges) {
    if (changes && this.appScrollToElement() && this.bps.isLarge()) {
      setTimeout(() => {
        this.element.nativeElement.scrollIntoView({
          block: this.block(),
          behavior: "smooth"
        });
      }, 150);
    }
  }
}
